import React from "react";
import {
  Typography,
  Grid,
} from "@material-ui/core";

export default function Voucher({ removal }) {
  return (
    <Grid item xs={12} sm={6} md={6}>
      <Typography
        variant="h5"
      >
        Voucher
      </Typography>
      <Typography
        multiline
        label="Descripción"
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
        style={{ padding: "2%", fontSize:"19px" }}
      >
        
        <img src={removal.urlVoucher} width="100%"></img>
      </Typography>
    </Grid>
  );
}
